import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef } from 'react'
import { useToaster } from '../../../contexts/Toaster'

const EditUser = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const formName = 'editUser'
    const { user, loadUser } = modal.$state.data

    const editUserRef = useRef()
    editUserRef.current = () => {
        const formValues = form.$state.value

        koalition.put(`users/${user._id}`, formValues).then((response) => {
            loadUser()
            modal.close()
            toaster.success('User updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => editUserRef.current(), controls: {
        email: { validators: [Validators.required, Validators.email], value: user.email },
        discordId: { validators: [Validators.required], value: user.discordId },
    } })

    useEffect(() => {        
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <>
            {form.$state && (
                <>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <Input control={form.$state.controls.email} label="Name" />
                        </div>

                        <div className="col-md-6 mb-3">
                            <Input control={form.$state.controls.discordId} label="Discord Id" />
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default EditUser